import { PlanDetails } from './types'

export const SYSTEM_SEND_STRIPE_ID = '14535'

export const planDetails: PlanDetails[] = [
  {
    plan: 'Basic',
    details: [
      { detail: '$2.75 per card' },
      {
        detail: 'Tiered pricing for System Sends',
        innerDetails: [
          { detail: '$2.75 per card' },
          { detail: '$2.50 per card for 25+' },
          { detail: '$2.25 per card for 50+' },
          { detail: '$2.00 per card for 100+' },
        ],
      },
      { detail: 'Full retail price on gifts' },
      { detail: 'Enhanced Storage' },
      { detail: 'Postage not included on any card sends' },
    ],
  },
  /****************************************************** 37 start **************************************************************/
  {
    plan: '$37 Card A Day',
    details: [
      {
        detail: '30 Monthly Cards (includes both Heartfelt and System Cards)',
        innerDetails: [
          {
            detail: '$1.75 for each additional card over 30.',
          },
          {
            detail: 'Stamps not included on any cards',
          },
        ],
      },
      {
        detail: 'Contact Manager',
        innerDetails: [
          {
            detail:
              'Store your contact information, birthdays, special occasions, reminders, include notes, and get a history of every card sent.',
          },
        ],
      },
      {
        detail: '20% Discount on Gifts',
        innerDetails: [
          {
            detail:
              'Each gift that you add to greeting cards gets you even more savings!',
          },
        ],
      },
    ],
  },
  /****************************************************** 97 start **************************************************************/
  {
    plan: '$97 Unlimited',
    description: 'Includes 30 System Cards',
    isFeatured: true,
    details: [
      {
        detail: 'UNLIMITED Photo Postcards!',
        innerDetails: [
          {
            detail:
              'Send unlimited heartfelt 4x6 postcards - stamps included, mailed out when you hit SEND!',
          },
        ],
      },
      {
        detail: 'UNLIMITED Heartfelt Prompting Cards!',
        innerDetails: [
          {
            detail:
              'Send an unlimited amount of 5x7 greeting cards, also with stamps included. We stuff, stamp, and mail them for you immediately! ',
          },
        ],
      },
      {
        detail: 'Contact Manager',
        innerDetails: [
          {
            detail:
              'Store your contact information, birthdays, special occasions, reminders, include notes, and get a history of every card sent.',
          },
        ],
      },
      {
        detail: '30 System Cards!',
        innerDetails: [
          {
            detail:
              'Our Automated sending process does all the work for you, schedule, send to one or multiple people, even take advantage of our drip campaign feature!',
          },
          {
            detail:
              '$1.50 per additional System Card. Stamps not included on any System Card sends.',
          },
        ],
      },
      {
        detail: '30% Discount on Gifts',
        innerDetails: [
          {
            detail:
              'Each gift that you add to greeting cards gets you even more savings!',
          },
        ],
      },
      {
        detail: '30% Savings on Shipping',
        innerDetails: [
          {
            detail:
              'Get even more savings when you ship your greeting card with a gift. We have you covered!',
          },
        ],
      },
    ],
  },
  /****************************************************** 147 start **************************************************************/
  {
    plan: '$147 Unlimited',
    description: 'Includes 100 System Cards',
    details: [
      {
        detail: 'UNLIMITED Photo Postcards!',
        innerDetails: [
          {
            detail:
              'Send unlimited heartfelt 4x6 postcards - stamps included, mailed out when you hit SEND!',
          },
        ],
      },
      {
        detail: 'UNLIMITED Heartfelt Prompting Cards!',
        innerDetails: [
          {
            detail:
              'Send an unlimited amount of 5x7 greeting cards, also with stamps included. We stuff, stamp, and mail them for you immediately! ',
          },
        ],
      },
      {
        detail: 'Contact Manager',
        innerDetails: [
          {
            detail:
              'Store your contact information, birthdays, special occasions, reminders, include notes, and get a history of every card sent.',
          },
        ],
      },
      {
        detail: '100 System Cards!',
        innerDetails: [
          {
            detail:
              'Our Automated sending process does all the work for you, schedule, send to one or multiple people, even take advantage of our drip campaign feature!',
          },
          {
            detail:
              '$1.25 per additional System Card. Stamps not included on any System Card sends.',
          },
        ],
      },
      {
        detail: 'Unlimited Campaign Store Free Downloads',
        innerDetails: [
          {
            detail:
              'You get access to all of the pre-designed card campaigns to use for automated card follow up. ',
          },
        ],
      },
      {
        detail: '30% Discount on Gifts',
        innerDetails: [
          {
            detail:
              'Each gift that you add to greeting cards gets you even more savings!',
          },
        ],
      },
      {
        detail: '30% Savings on Shipping',
        innerDetails: [
          {
            detail:
              'Get even more savings when you ship your greeting card with a gift. We have you covered!',
          },
        ],
      },
      { detail: 'Expense account required on this plan' },
    ],
  },
  /****************************************************** 247 start **************************************************************/
  {
    plan: '$247 Unlimited',
    description: 'Includes 250 System Cards',
    details: [
      {
        detail: 'UNLIMITED Photo Postcards!',
        innerDetails: [
          {
            detail:
              'Send unlimited heartfelt 4x6 postcards - stamps included, mailed out when you hit SEND!',
          },
        ],
      },
      {
        detail: 'UNLIMITED Heartfelt Prompting Cards!',
        innerDetails: [
          {
            detail:
              'Send an unlimited amount of 5x7 greeting cards, also with stamps included. We stuff, stamp, and mail them for you immediately! ',
          },
        ],
      },
      {
        detail: 'Contact Manager',
        innerDetails: [
          {
            detail:
              'Store your contact information, birthdays, special occasions, reminders, include notes, and get a history of every card sent.',
          },
        ],
      },
      {
        detail: '250 System Cards!',
        innerDetails: [
          {
            detail:
              'Our Automated sending process does all the work for you, schedule, send to one or multiple people, even take advantage of our drip campaign feature!',
          },
          {
            detail:
              '$1.00 per additional System Card. Stamps not included on any System Card sends.',
          },
        ],
      },
      {
        detail: 'Unlimited Campaign Store Free Downloads',
        innerDetails: [
          {
            detail:
              'You get access to all of the pre-designed card campaigns to use for automated card follow up. ',
          },
        ],
      },
      {
        detail: '30% Discount on Gifts',
        innerDetails: [
          {
            detail:
              'Each gift that you add to greeting cards gets you even more savings!',
          },
        ],
      },
      {
        detail: '30% Savings on Shipping',
        innerDetails: [
          {
            detail:
              'Get even more savings when you ship your greeting card with a gift. We have you covered!',
          },
        ],
      },
      { detail: 'Expense account required on this plan' },
    ],
  },
  {
    plan: 'Enterprise',
    details: [
      { detail: 'Unlimited Heartfelt Single Card Sends Including Stamps' },
      { detail: '$1.75/Group and Scheduled Cards' },
      { detail: '30% Discount on Gifts *' },
      { detail: 'Includes All Card Types' },
      { detail: '100 Free Cards Toward Group Sends Per Month' },
      { detail: 'Premium Storage' },
      { detail: 'Loyalty Rewards' },
      { detail: '+ Enhanced Plan Features' },
    ],
  },
]
